'use strict';

import ss from 'socket.io-stream';
import * as angular from 'angular';

angular.module('paizacloudApp')
  .controller('ModalFileUploadCtrl', function($scope, $uibModalInstance, container, target, Upload, files, $timeout, $http){

    $scope.progress = {
      percentage: 0,
      active: false,
    };


    $scope.uploadFiles = function(files) {
      console.log("uploadFiles: container=", container);
      console.log("uploadFiles: files=", files);
      console.log("uploadFiles: target=", target);
      /*

      var containerElement = $(".container-" + container.containerId);
      console.log("containerElement:", containerElement);
      var jstreeElement = containerElement.find("js-tree");
      console.log("jstreeElement:", jstreeElement);
      var selected = jstreeElement.jstree("get_selected");
      console.log("selected:", selected);
      console.log("selected.li_attr:", selected.li_attr)
      console.log("scope", $scope);
      var f = $scope.parent.files[file];
      console.log("f:", f);

      var selectedOne = "/root";
      if(selected && selected.length>0){
        selectedOne = selected[0];
      }
      console.log("selectedOne:", selectedOne);
      */

      /*
      var url = '/api/containers/' + container.containerId + '/upload';
      Upload.upload({
        url: url,
        data: {
          files: files,
          "Content-Type": 'application/octet-stream',
          // fileFormDataName: 'photo',
          target: target,
        },
        arrayKey: '', // for milter
      }).progress(function(evt){
        $scope.progress.percentage = parseInt(100 * evt.loaded / evt.total);
        console.log('progress: ' + $scope.progress.percentage);
      }).success(function(data, status, headers, config){
        // console.log('file:' + config.file.name + ' uploaded. Response: ', data);
        $scope.progress.active = false;
        $scope.progress.message = 'Uploaded!';
      }).error(function(data, status, headers, config){
        console.log('Error status: ', status);
        $scope.progress.active = false;
      });
      $scope.progress.active = true;
      */

      $scope.progress.active = true;

      /*
        Blob saved as [object Object] Nodejs
        http://stackoverflow.com/a/24003932/1309218
      */
      function blobToBase64(blob, cb) {
        const reader = new FileReader();
        reader.onload = () => {
          const dataUrl = reader.result;
          const base64 = (<string>dataUrl).split(',')[1];
          // console.log('onload', reader, reader.result, blob, dataUrl, base64);
          cb(base64);
        };
        reader.readAsDataURL(blob);
      }

      function blobToBase64Promise(blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            const dataUrl = reader.result;
            const base64 = (<string>dataUrl).split(',')[1];
            // console.log('onload', reader, reader.result, blob, dataUrl, base64);
            resolve(base64);
          };
          reader.readAsDataURL(blob);
        });
      }

      function sendFileDone(){
        console.log('all done');
        $scope.progress.active = false;
        $scope.progress.message = 'Uploaded!';
        $scope.ok();
      }

      function sendFileBySocketStream(file, targetFilename){
        return new Promise<void>((resolve, reject) => {
          blobToBase64(file, function(base64){
            let ssocket = ss(container.socket.ioSocket);
            let stream = ss.createStream();
            ssocket.emit('writeFile', targetFilename, stream, {encoding: 'base64', mkdir: 'true'}, function(result){
              console.log("written:result=", result);
              resolve();
            });
            const blobStream = ss.createBlobReadStream(file);
            let size = 0;
            blobStream.on('data', (chunk) => {
              size += chunk.length;
              console.log('size=' + size + ', filesize=' + file.size + ', percent=' + Math.floor(size / file.size * 100) + '%')
            });
            blobStream.pipe(stream);
          });
        });
      }

      function sendFileBySocket(file, targetFilename){
        return new Promise<void>((resolve, reject) => {
          blobToBase64(file, function(base64){
            container.socket.emit('writeFile', targetFilename, base64, {encoding: 'base64', mkdir: 'true'}, function(result){
              console.log("written:result=", result);
              resolve();
            });
          });
        });
      }
      function sendFileByPost(file, targetFilename){
        let baseUrl = container.containerAgentUrl;
        const writeFileUrl = `${baseUrl}/api/writeFile?access_token=${container.containerToken}`;
        $scope.progress.active = true;
        return Promise.resolve()
          .then(() => {
            return blobToBase64Promise(file);
          })
          .then((base64) => {
            return $http.post(writeFileUrl, {
              filename: targetFilename,
              data: base64,
              options: {
                encoding: 'base64',
                mkdir: 'true',
              }
            },{
              uploadEventHandlers: {
                progress: (event) => {
                  console.log("uploadEventHandlers:progress:event=", event);
                  $scope.progress.percentage = 100 * event.loaded / event.total;
                  $scope.progress.message = `${Number(event.loaded).toLocaleString()}Byte/${Number(event.total).toLocaleString()}Byte (${Math.floor($scope.progress.percentage*10)/10}%)`;
                  console.log('progress: ' + $scope.progress.percentage);
                }
              }
            });
          });
      }

      function sendFileByMultipartFormEncode(file:File, targetFilename:string){
        const formData = new FormData();
        formData.append('filename', targetFilename);
        formData.append('file', file);
        let baseUrl = container.containerAgentUrl;
        const uploadFileUrl = `${baseUrl}/api/upload?access_token=${container.containerToken}`;
        $scope.progress.active = true;
        return $http.post(uploadFileUrl, formData, {
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined,
          },
          uploadEventHandlers: {
            progress: (event) => {
              console.log("uploadEventHandlers:progress:event=", event);
              $scope.progress.percentage = 100 * event.loaded / event.total;
              $scope.progress.message = `${Number(event.loaded).toLocaleString()}Byte/${Number(event.total).toLocaleString()}Byte (${Math.floor($scope.progress.percentage*10)/10}%)`;
              console.log('progress: ' + $scope.progress.percentage);
            }
          }
        });
      }

      function sendFile(file){
        // const file = files[i];
        console.log("sendfile(): file=", file);
        const filename = file.path || file.name;
        console.log("sendfie(): filename=", filename);
        /*
        var pos;
        if((pos=filename.indexOf('/'))!==-1){
          filename = filename.substr(pos+1);
        }
        */
        const targetFilename = target + '/' + filename;
        console.log("sendfile():targetFilename=", targetFilename);
        // var blob = Blob.slice(file);

        // return sendFileBySocket(file, targetFilename);
        // return sendFileByPost(file, targetFilename);
        return $http.get(`${container.containerAgentUrl}/version?access_token=${container.containerToken}`)
          .then((response) => {
            const version = parseFloat(response.data);
            console.log("sendFile: api version=", version);
            if(version>=1.1) {
              return sendFileByMultipartFormEncode(file, targetFilename);
            }else{
              return sendFileByPost(file, targetFilename);
            }
          });
        /*
        blobToBase64(file, function(base64){
          container.socket.emit('writeFile', targetFilename, base64, {encoding: 'base64', mkdir: 'true'}, function(result){
            console.log("written:result=", result);
            if(i === files.length - 1){
              sendFileDone();
            }else{
              sendFile(i + 1);
            }
          });
        });
        */
      }
      let p = Promise.resolve();
      for(let i=0; i<files.length; i++){
        const file = files[i];
        p = p.then(() => {
          return sendFile(file);
        });
      }
      p = p.then(() => {
        return sendFileDone();
      })
        .catch((error) => {
          console.log('modalFileUpload error', error);
          const msg = error.data ? (error.data.message || JSON.stringify(error.data, null, 2)) : error.toString();
          window.swal('Error', msg, 'error');
          $scope.cancel();
        });
      // sendFile(0);
      /*
        for(let i=files.length-1; i>=0; i--){
          (function(){
            var file = files[i];
            var next2 = next;
            var cur = function(){
              sendFile(file, next2);
            };
            next = cur;
          })();
        }
        next();
      */
    };

    $scope.ok = function() {
      console.log('modalFileUpload: ok');
      $uibModalInstance.close('ok');
    };
    $scope.cancel = function (){
      console.log('modalFileUpload: cancel');
      $uibModalInstance.dismiss('cancel');
    };

    if (files){
      $timeout(function(){
        $scope.uploadFiles(files);
      }, 0);
    }

  });

class PCModalFileUploadService{
  /*@ngInject*/
  constructor(private $uibModal){
  }
  open(container, target, files):Promise<string>{
    return this.$uibModal.open({
      size: 'lg',
      template: require('./modalFileUpload.html').default,
      controller: 'ModalFileUploadCtrl',
      controllerAs: '$ctrl',
      resolve: {
        container: () => container,
        target: () => target,
        files: () => files,
      },
    }).result;
  }
}

angular.module('paizacloudApp')
  .service('PCModalFileUploadService', PCModalFileUploadService);

